export default __webpack_public_path__ + "static/media/ic_ghost.111db4bd.svg";